/**
 * MaintenanceTasks Section Component
 *
 * Displays maintenance task summary.
 */

import React from 'react'
import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography
} from '@mui/material'
import BuildIcon from '@mui/icons-material/Build'
import { MaintenanceSummary } from '../../../../../services/reportsApi'
import Metric from '../Metric'

interface MaintenanceTasksProps {
  data: MaintenanceSummary
}

const MaintenanceTasks: React.FC<MaintenanceTasksProps> = ({ data }) => {
  return (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          <BuildIcon color="primary" />
          <Typography variant="h6" component="h2">
            Maintenance Tasks
          </Typography>
        </Box>

        <Grid container spacing={2}>
          <Grid item xs={4}>
            <Metric
              label="Tokens Refreshed"
              value={data.token_refreshes_success}
              color="#2e7d32"
            />
          </Grid>
          <Grid item xs={4}>
            <Metric
              label="Token Failures"
              value={data.token_refreshes_failed}
              color={data.token_refreshes_failed > 0 ? '#d32f2f' : 'text.primary'}
            />
          </Grid>
          <Grid item xs={4}>
            <Metric
              label="Health Checks"
              value={data.health_checks}
            />
          </Grid>
          <Grid item xs={4}>
            <Metric
              label="Stale Data"
              value={data.stale_data_detected}
              color={data.stale_data_detected > 0 ? '#ed6c02' : 'text.primary'}
            />
          </Grid>
          <Grid item xs={4}>
            <Metric
              label="Syncs Triggered"
              value={data.syncs_triggered}
            />
          </Grid>
          <Grid item xs={4}>
            <Metric
              label="Cleanups"
              value={data.cleanups}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default MaintenanceTasks
